import React, { useEffect, useState } from 'react'

import { Form,Select,Input,Row, Col,Switch,Alert} from "antd";
import Services from '../../network/Services';
import konsole from '../../network/konsole'
import "./Seminar.css"

const ListSeminar = ({ setPublishSeminar, publishseminar, setPastSeminar,setSearchSeminar, changeBorderToTopButtons, setChangeBorderToTopButtons,setfilteredSubtinentId}) => {
  const [btnborder, setbtnborder] = useState(1)
  const[checkclick,setcheckclick]=useState(false)
  const[togglecheckbox,settogglecheckbox]=useState(true)
  const [allSubtinents, setallSubtinents] = useState()
  let userroleId = JSON.parse(sessionStorage.getItem("stateObj")).roleId;
  let subtenantId = sessionStorage.getItem("subtenantId")
  let userLoggedInDetail = JSON.parse(sessionStorage.getItem("userLoggedInDetail"))
  const { Option } = Select;


  const [localSearchValue, setLocalSearchValue] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchSeminar(localSearchValue);
    }, 300);
    return () => clearTimeout(timer);
  }, [localSearchValue, setSearchSeminar]);


  useEffect(()=>{
    if(changeBorderToTopButtons == 1){
      setbtnborder(1)
      setChangeBorderToTopButtons(0)
    }
  },[changeBorderToTopButtons])

  useEffect(()=>{
    if(publishseminar === true){
      setbtnborder(1)
    } else {
      setbtnborder(2)
      settogglecheckbox(true)
    }
  },[publishseminar])

useEffect(() => {
  Services.postSubtenantDetails().then((res)=>{
    setallSubtinents(res.data.data)
  })
}, [])


  const pubseminar = () => {
    setPublishSeminar(true)
    setbtnborder(1)

  }

  const pubishseminar = () => {
    setPastSeminar('Present')
    setPublishSeminar(false)
    setbtnborder(2)
    setcheckclick(false)
    settogglecheckbox(true)
    document.getElementById('publishSeminar').style.border = '2px solid #720c20'

  }

  const checkbox = (e) => {
    if (e.target.checked == true) {
      setPastSeminar("Past")
      setPublishSeminar(false)
      setbtnborder(3)
      setcheckclick(true)
    } else {
      btnborder(2)
      setPastSeminar('Present')
      setPublishSeminar(false)
      setcheckclick(false)
    }


  }

  const togglecheckboxchange=(e)=>{
    settogglecheckbox(e)
    if(e==true){
      setPastSeminar('Present')
    }else{
      setPastSeminar('past')
    }

  }
  const onChangeData = (value, key) => {
    setfilteredSubtinentId(key.value)

  };

  return (

    <div className='pt-2'style={{borderBottom:"1px solid #BFBFBF"}}>
    {(btnborder == 1 || userroleId == 6) && (
     <button className={`${btnborder == 1 ? (userroleId == 6 ? "schedule-active2" : "schedule-active") : ""} me-2 schedule ps-0`} onClick={pubseminar}>Publish Seminar</button>)}
    {(btnborder == 2 || userroleId == 6 ) && <button className={`${btnborder == 2 ? (userroleId == 6 ? "schedule-active2" : "schedule-active") : ""} me-2 schedule ps-0`} onClick={pubishseminar}> Published Seminar</button>
    }
      {
        (publishseminar==false) ? <>
      <Row span={24} className="" >
        <Col span={24}>
          <div style={{ display: "flex", alignItems: "center", paddingLeft:"5px", marginBottom:"10px", gap: "12px" }}>
            <Col span={10}>
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #C3C3C3", borderRadius: "4px", height: "40px", 
                paddingLeft: "12px", paddingRight: "8px", backgroundColor: "#fff" }}>
                <img src="./search.svg" alt="search" style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0 }} />
                <input placeholder="Search for Seminar" value={localSearchValue} onChange={(e) => setLocalSearchValue(e.target.value)}
                  style={{ border: "none", outline: "none", width: "100%", fontSize: "14px", color: "#333", backgroundColor: "transparent" }}/>
              </div>
            </Col>

            <Col span={6}>
              {userroleId == 4 &&
            <Form.Item
                name="seminarOrganizingPartner"
                className='ms-4'
              >
                <Select
                  onChange={onChangeData}
                  allowClear
                  style={{  }}
                  placeholder="Select your Subtenant"
                  defaultValue={userLoggedInDetail?.subtenantName}
                  value={subtenantId}
                >
                  {
                    allSubtinents?.map((items, index) => {
                      return <Option value={items.subtenantId} key={items.value}>
                        {items.subtenantName}
                        </Option>
                    })
                  }

                </Select>
              </Form.Item>}
            </Col>

          {/* Upcoming / Past toggle buttons*/}

            <div className="ms-auto" style={{ display: "inline-flex", backgroundColor: "#e8e8e8", borderRadius: "2px", height: "44px", padding: "4px", gap: "2px", flexShrink: 0 }}>
              <button
                onClick={() => togglecheckboxchange(true)}
                style={{
                  padding: "6px 10px",
                  borderRadius: "1.5px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "14px",
                  backgroundColor: togglecheckbox === true ? "#720C20" : "#F0F0F0",
                  color: togglecheckbox === true ? "#fff" : "#444",
                  outline: "none",
                }}>
                Upcoming
              </button>
              <button
                onClick={() => togglecheckboxchange(false)}
                style={{
                  padding: "6px 10px",
                  borderRadius: "1.5px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "normal",
                  fontSize: "14px",
                  backgroundColor: togglecheckbox === false ? "#720C20" : "#F0F0F0",
                  color: togglecheckbox === false ? "#fff" : "#444",
                  outline: "none",
                }}>
                Past
              </button>
            </div>
          </div>
        </Col>
      </Row>
        </> :""
      }


    </div>


  )
}

export default ListSeminar